import React, { useEffect } from "react";
import AddOfficerForm from "../form/AddOfficerForm";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import { ADD_OFFICER, OFFICER_SETUP } from "../apiEndpoints";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import spin from "../../../assets/icons/spin.png";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";

const AddOfficerPage = () => {
  const { executePost, loading, formError, setFormError, successResponse } =
    usePostData();
  const { data, isLoaded, error, getData } = useGetData();

  useEffect(() => {
    getData(OFFICER_SETUP);
  }, []);

  // execute post api
  const sendData = async (formDataObj, reset, setLevelDropdown) => {
    const updateStateOnResponse = () => {
      setLevelDropdown([]);
      // reset form value
      reset();
    };
    //API calling
    executePost(formDataObj, ADD_OFFICER, updateStateOnResponse);
  };
  return (
    <MainPageLayout headerConfig={{ title: "Add Officer" }}>
      {isLoaded && !error ? (
        <AddOfficerForm
          officerSetup={data}
          sendData={sendData}
          loading={loading}
          successResponse={successResponse}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default AddOfficerPage;
